class FetchUrl {
  async fetchJson(url) {
    const response = await fetchWithTimeout(url);
    return response.json();
  }

  async fetchScripts(...scriptsUrls) {
    const fetchLibraries = scriptsUrls.map((scriptUrl) => fetchScript(scriptUrl));
    return Promise.all(fetchLibraries);

    async function fetchScript(dependencyLink) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.addEventListener("load", resolve);
        script.addEventListener("error", reject);
        script.async = true;
        script.src = dependencyLink;
        document.body.append(script);
      });
    }
  }
}

async function fetchWithTimeout(url, timeout = 10_000) {
  return Promise.race([
    fetch(url),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error(`Timeout on ${url} request`)), timeout),
    ),
  ]);
}

const fetchUrl = new FetchUrl();
export { FetchUrl, fetchUrl };